var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconManageAthletes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.382,
    height: 26.868,
    viewBox: "0 0 38.382 26.868",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-friends",
    "data-name": "Icon awesome-user-friends",
    d: "M11.515,15.684A6.717,6.717,0,1,0,4.8,8.967,6.714,6.714,0,0,0,11.515,15.684ZM16.121,17.6h-.5a9.274,9.274,0,0,1-8.216,0h-.5A6.911,6.911,0,0,0,0,24.512v1.727a2.879,2.879,0,0,0,2.879,2.879H20.151a2.879,2.879,0,0,0,2.879-2.879V24.512A6.911,6.911,0,0,0,16.121,17.6Zm12.666-1.919a5.757,5.757,0,1,0-5.757-5.757A5.759,5.759,0,0,0,28.787,15.684ZM31.665,17.6h-.228a7.563,7.563,0,0,1-5.3,0h-.228a6.661,6.661,0,0,0-3.34.924,8.777,8.777,0,0,1,2.381,5.985v2.3c0,.132-.03.258-.036.384H35.5a2.879,2.879,0,0,0,2.879-2.879A6.714,6.714,0,0,0,31.665,17.6Z",
    transform: "translate(0 -2.25)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconManageAthletes);
export default __webpack_public_path__ + "static/media/icon-manage-athletes.5e0c3c78f2a1f75989004d71aaa35d05.svg";
export { ForwardRef as ReactComponent };